import React from "react";
import { CustomTextField } from "../../../../../../components/CustomTextField";
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import { CleanIcon } from "../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import { DINERS_TABS, FOODIE_SHIFT_RESOURCE, STEPS_CREATE_FOODIE_SHIFT } from "../../Model/Models";
import { AddShiftResourceApp } from "../../Functionality/AddShiftResourceApp";
import { AssignedShiftResourceApp } from "../../Functionality/AssignedShiftResourceApp";
import TabPanel from "../../../../../../components/ResourceAssignment/TabPanel";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * First foodie shift section: shift name + diners (cafeterias) Add/Assigned tab
 * panel. Mirrors the attendance SectionAccessDevices.
 */
const SectionDiners = ({
                           id,
                           item,
                           handleChange,
                           emptyFields,
                           disabled,
                           handleClearStep,
                           cafeterias,
                           setCafeterias,
                           selectDeleteCafeterias,
                           setSelectDeleteCafeterias,
                           searchElement,
                           setSearchElement,
                           modified,
                           setModified,
                           mainContainerClass
                       }) => {
    return (
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {(id === null || typeof id === 'undefined') &&
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_sd_clean_diners'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => handleClearStep(STEPS_CREATE_FOODIE_SHIFT.DINERS.INDEX)}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                     }
                </div>

                <div className={"col-12"}>
                    <CustomTextField
                        id='txt_sd_name'
                        name='name'
                        value={item?.name}
                        trans='name'
                        type='text'
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields && (item?.name === '' || !item?.name)}
                        required={true}
                        length={64}
                    />
                </div>

                <div className={"col-12"}>
                    <TabPanel
                        resource={FOODIE_SHIFT_RESOURCE.CAFETERIAS}
                        tabsConfig={DINERS_TABS}
                        selected={cafeterias}
                        setSelected={setCafeterias}
                        selectForDelete={selectDeleteCafeterias}
                        setSelectForDelete={setSelectDeleteCafeterias}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        modified={modified}
                        setModified={setModified}
                        id={id}
                        deleteButtonId={'btn_sd_delete'}
                        useAddApp={AddShiftResourceApp}
                        useAssignedApp={AssignedShiftResourceApp}
                        mainContainerClass={mainContainerClass}
                        emptyFields={emptyFields && cafeterias?.length === 0}
                        disabled={disabled}
                    />
                </div>
            </div>
    );
}

export default SectionDiners
